<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import html2pdf from 'html2pdf.js'
import Widget from './widget'

export default {
	page: {
		title: '360MDR Reports',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: {
		Layout,
		Widget
	},
	props: {
		name: {
			type: String,
			default: 'main.json'
		}
	},
	data() {
		return {
			finishedWidgetsCount: 0,
			widgetsStatus: [],
			startDateTime: null,
			endDateTime: null,
			startDateTimeShow: null,
			endDateTimeShow: null,
			error: null,
			title: 'Reporte Microsoft 365 - Corona',
			spacer: '',
			startEpoch: 0,
			endEpoch: 0,
			date: null,
			dateTimePicker: {
				enableTime: true,
				dateFormat: 'm/d/Y H:i',
			},
			tops: [3,5,10,20,25,50,100,200,500],
			top: 10,
			dashboard: {
				"widgets": [
					{
            			"source": "/pan/xdr/count/timerange/other?collection=azure_events&tvariable=CreationTime&variable=_id",
						"id": "info2",
						"name": "Eventos totales en el rango de tiempo",
						"cols": "col-md-6",
						"height_class": "small",
						"component": "vindicator",
						"refresh": 60000,
						"range": true,
						"trend": false
					},
					{
            			"source": "/pan/xdr/count/timerange/other?collection=azure_events_alarms&tvariable=start&variable=_id",
						"id": "info4",
						"name": "Alarmas totales en el rango de tiempo",
						"cols": "col-md-6",
						"height_class": "small",
						"component": "vindicator",
						"refresh": 60000,
						"range": true,
						"trend": false
					},
					{
						"source": "/pan/xdr/agg/date/auto?collection=azure_events&variable=CreationTime",
						"id": "widget2",
						"name": "CANTIDAD DE EVENTOS MICROSOFT 365",
						"cols": "col-md-6",
						"height_class": "tall_widget",
						"component": "dbar",
						"type": "bar",
						"colors": ["#DC001E"],
						"range": true,
						"refresh": 60000
					},
					{
						"source": "/pan/xdr/agg/date/auto?collection=azure_events_alarms&variable=start",
						"id": "widget2",
						"name": "CANTIDAD DE ALARMAS DE MICROSOFT 365",
						"cols": "col-md-6",
						"height_class": "tall_widget",
						"component": "dbar",
						"type": "bar",
						"colors": ["#0084FF"],
						"range": true,
						"refresh": 60000
					},
					{
						"source": "/pan/xdr/agg/general?collection=azure_events_alarms&variables=severity&outvars=label&tvariable=start",
						"source1": "/pan/xdr/agg/general?collection=cortex_incidents&variables=incident.incident.severity&outvars=label&tvariable=incident.incident.modification_time&limit=3",
						"id": "widget2",
						"name": "ALARMAS DE MICROSOFT 365 POR SEVERIDAD",
						"cols": "col-md-6",
						"height_class": "tall_widget",
						"component": "dpie",
						"type": "donut",
						"colorsByLabel": {
							"high": "#DC001E",
							"medium": "#FECA00",
							"low": "#01AD00"
						},
						"range": true,
						"refresh": 60000
					},
					{
						"source": "/pan/xdr/agg/general?collection=azure_events_alarms&variables=type&outvars=label&tvariable=start",
						"id": "widget2",
						"name": "ALARMAS DE MICROSOFT 365 POR TIPO",
            			"cols": "col-md-6",
						"height_class": "tall_widget",
						"component": "dpie",
						"type": "donut",
						"colors": ['#0084FF', '#1ab7ea', '#0084ff', '#39539E', '#0077B5'],
						"range": true,
						"refresh": 60000
					},
					{
						"source": "/pan/xdr/generic/top?collection=azure_events_alarms&variables=target,title&outvars=target,title&tvariable=end&limit={$limit}&altorder=count&maxlength=100",
						"name": "TOP #{limit} DE ALARMAS DE MICROSOFT 365",
						"id": "widget2222",
						"cols": "col-md-12",
						"height_class": "short_widget",
						"component": "multicolumn",
						"range": true,
						"refresh": 60000,
						"error": "No hay alarmas en el rango de tiempo.",
						"cardStyle": "overflow: auto;"
					},
					{
						"source": "/pan/xdr/alerts/top?collection=azure_events&variables=Operation&outvars=reference&tvariable=CreationTime&limit={$limit}",
						"name": "TOP #{limit} DE OPERACIONES EN EVENTOS DE MICROSOFT 365",
						"cols": "col-md-12",
						"height_class": "short_widget",
						"component": "multicolumn",
						"range": true,
						"error": "No hay operaciones en los eventos de Microsoft 365 en el rango de tiempo.",
						"refresh": 60000,
						"cardStyle": "overflow:auto"
					},
					{
						"source": "/pan/xdr/alerts/top?collection=azure_events&variables=UserId&outvars=reference&tvariable=CreationTime&limit={$limit}",
						"id": "widget2",
						"name": "TOP #{limit} DE USUARIOS EN EVENTOS DE MICROSOFT 365",
						"cols": "col-md-12",
						"height_class": "short_widget",
						"component": "multicolumn",
						"range": true,
						"error": "No hay usuarios en los eventos de Microsoft 365 en el rango de tiempo.",
						"refresh": 60000,
						"cardStyle": "overflow:auto"
					},
					{
						"source": "/pan/xdr/alerts/top?collection=azure_events&variables=ClientIP&outvars=reference&tvariable=CreationTime&limit={$limit}",
						"name": "TOP #{limit} DE HOSTS EN EVENTOS DE MICROSOFT 365",
						"id": "widget21",
						"cols": "col-md-12",
						"height_class": "short_widget",
						"component": "multicolumn",
						"range": true,
						"error": "No hay hosts en los eventos de Microsoft 365 en el rango de tiempo.",
						"refresh": 60000,
						"cardStyle": "overflow:auto"
					},
					{
						"source": "/pan/xdr/alerts/top?collection=azure_events&variables=intelligence.geoip.country_name&outvars=reference&tvariable=CreationTime&limit={$limit}",
						"name": "TOP #{limit} DE PAÍSES EN EVENTOS DE MICROSOFT 365",
						"id": "widget222",
						"cols": "col-md-12",
						"height_class": "short_widget",
						"component": "multicolumn",
						"range": true,
						"error": "No hay países en los eventos de Microsoft 365 en el rango de tiempo.",
						"refresh": 60000,
						"cardStyle": "overflow:auto"
					},
					{
						"source": "/pan/xdr/alerts/top?collection=azure_events&variables=AppName&outvars=reference&tvariable=CreationTime&limit={$limit}",
						"name": "TOP #{limit} DE APLICACIONES EN EVENTOS DE MICROSOFT 365",
						"id": "widget21",
						"cols": "col-md-12",
						"height_class": "short_widget",
						"component": "multicolumn",
						"range": true,
						"error": "No hay aplicaciones en los eventos de Microsoft 365 en el rango de tiempo.",
						"refresh": 60000,
						"cardStyle": "overflow:auto"
					},
					{
						"source": "/pan/xdr/alerts/top?collection=azure_events&variables=ClientApp&outvars=reference&tvariable=CreationTime&limit={$limit}",
						"name": "TOP #{limit} DE APLICACIONES CLIENTE EN EVENTOS DE MICROSOFT 365",
						"id": "widget222",
						"cols": "col-md-12",
						"height_class": "short_widget",
						"component": "multicolumn",
						"range": true,
						"error": "No hay aplicaciones cliente en los eventos de Microsoft 365 en el rango de tiempo.",
						"refresh": 60000,
						"cardStyle": "overflow:auto"
					},
				]
			},
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
			base: 0,
			pdfConfig: {
				margin: 0.2,
				filename: 'Microsoft 365 - Corona - Report.pdf',
				image: { type: 'jpeg', quality: 0.98 },
				html2canvas: { scale: 2, dpi: 96, letterRendering: true, width: 1280 },
				jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
				pagebreak: { mode: 'css', before: '#page2el' },
				_pageBreak: { mode: 'avoid-all', before: '.break-page', after:'.break-page'}
			},
		}
	},
	computed: {
		dateTimeFormatedRange: function () {
			let res = ''
			if (this.startDateTimeShow !== null) res += this.startDateTimeShow + ' - '
			if (this.endDateTimeShow !== null) res += this.endDateTimeShow 		
			return res
		}
	},
	mounted () {
		this.showModal()
	},
	methods: {
		showModal() {
			this.$refs['modal-datetime'].show()
		},
		handleOk (evt) {
			let that = this
			if (that.startDateTime === null) {
				that.error = "Please select a start date and time"
				evt.preventDefault()
			} else if (that.endDateTime === null) {
				that.error = "Please select an end date and time"
				evt.preventDefault()
			} else {
				that.startEpoch = parseInt(new Date(that.startDateTime).getTime()/1000)
				that.endEpoch = parseInt(new Date(that.endDateTime).getTime()/1000)
				that.base += 100
				// that.title = 'Reporte MICROSOFT 365'
				that.error = null
				that.startDateTimeShow = that.startDateTime
				that.endDateTimeShow = that.endDateTime
				that.finishedWidgetsCount = 0
				that.widgetsStatus = []
			}
		},
		widgetFinished(id, ok, aux) {
			this.finishedWidgetsCount += 1
			this.widgetsStatus.push({id: id, ok: ok, aux: aux})
		},
		downloadPdf() {
			const element = document.getElementById('pdfcontent')
			html2pdf(element, this.pdfConfig)
    	},
		topChanged() {
			this.finishedWidgetsCount = 0
			this.widgetsStatus = []
		}
	},
}
</script>

<template>
	<Layout>
		<div class="container" style="max-width: 1420px !important;">
			<br>
			<!-- {{ finishedWidgetsCount }} - {{ dashboard.widgets.length }} -->
			<br>
			<!-- {{ widgetsStatus }} -->
			<div class="row">
				<div class="col-md-6" style="text-align:center;">
					<label for="default">Report</label><br>
					<template v-if="finishedWidgetsCount === dashboard.widgets.length">
						<b-button class="btn btn-primary btn-sm mr-1" variant="light" @click="downloadPdf()">
							Download PDF
						</b-button>
					</template>
					<template v-else>
						<span>
							Generating...
						</span>
					</template>
				</div>
				<div class="col-md-6" style="text-align:center;">
					<div class="form-group mt-3 mt-sm-0">
                  	<label for="default">Top Number</label>
						<b-form-select
						v-model="top"
						:options="tops"
						placeholder="Choose a top number"
						@change="topChanged"
						>
						</b-form-select>
                	</div>
				</div>
			</div>
			<div id="pdfcontent" style="width:1280px;background-color: rgb(237, 239, 243); break-after: page; clear: both;padding-left:20px;padding-right:20px;">
				<section slot="pdf-content">
					<br><br><br>
					<div class="row">
						<div class="col-md-12 align-items-center" style="text-align:center">
							<h2 style="align:center;cursor:pointer;">
								{{ title }}
							</h2>
							<h4 style="align:center;cursor:pointer;" v-on:click="showModal">
								{{ dateTimeFormatedRange || 'últimas 24 horas'}}
							</h4>
						</div>
					</div>
					<br>
					<div class="row">
						<template v-for="(widget, index) in dashboard.widgets">
							<Widget v-bind:key="index + base + top"
								:id="widget.id"
								:title="widget.name"
								:component="widget.component"
								:source="widget.source"
								:cols="widget.cols"
								:trend="widget.trend"
								:wclass="widget.class"
								:type="widget.type"
								:colors="widget.colors"
								:colorsByLabel="widget.colorsByLabel"
								:range="widget.range"
								:cardStyle="widget.cardStyle"
								:start="startEpoch"
								:end="endEpoch"
								:error="widget.error"
								:limit="top"
								@finished="widgetFinished"
							/>
						</template>
					</div>
				</section>
			</div>
		</div>
		<b-modal
			ref="modal-datetime"
			id="incident.incident_id"
			size="xs"
			title="Select Time Range"
			:ok-only=true
			:centered=true
			:no-fade=true
			@ok="handleOk">
			<div class="row">
				<div class="col-md-6">
					<div class="form-group mb-3">
					<label>Start</label>
					<flat-pickr
						v-model="startDateTime"
						:config="dateTimePicker"
						class="form-control"
						placeholder="Date and Time"
					></flat-pickr>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group mb-3">
					<label>End</label>
					<flat-pickr
						v-model="endDateTime"
						:config="dateTimePicker"
						class="form-control"
						placeholder="Date and Time"
					></flat-pickr>
					</div>
				</div>
			</div>
			<div v-if="error !== null" class="row">
				<div class="col-md-12 severity_high" style="text-align:center">
					{{ error }}
				</div>
			</div>

		</b-modal>
	</Layout>
</template>


